import { useRef, memo } from "react";
import { toRGBA } from "../parser/utils";
import { useInlineEditor } from "../Text/Text";
import { useEditorContext } from "../EditorContext";

export const HeadingEditorWrapper = memo(({data}) => {

  const { editorOptions } = useEditorContext();

  const ref = useRef();

  useInlineEditor(ref, {
    toolbarGroups: [
      { name: "editing", groups: ["basicstyles"] },
      { name: "paragraph", groups: ["align", "paragraph"] },
      { name: "colors", groups: ["colors"] },
      "/",
      { name: "styles", groups: ["styles"] },
      { name: "links", groups: ["links"] },
    ],
    onEditorDataChange: (html) => {
      data.html = html;
    },
    mergetags: editorOptions.mergeTag,
  });

  return (
    <div
      style={{ padding: 0 }}
      ref={ref}
      dangerouslySetInnerHTML={{ __html: data.html }}
    />
  );
});


export default (node) => {
  const { data } = node;
  const { paddingTop, paddingBottom, paddingRight, paddingLeft, backgroundColor } = data;

 

  return (
    <div style={{ paddingTop, paddingBottom, paddingRight, paddingLeft, backgroundColor: toRGBA(backgroundColor), }}>
      <HeadingEditorWrapper data={data} />
    </div>
  );
};
